import { modal } from "./modules/_modal";
modal();

let apiUrl;

// Environment and API variables
const coreApi = document.querySelector("html").dataset.core || `api`;
apiUrl = `https://${coreApi}.ayahealthcare.com/Locumsweb/Job/search`;

let apiArr = [];
featuredJobsProfessions.forEach((prof) => {
  apiArr.push(
    apiUrl +
      `?professionCode=${prof.value}&IncludeRelatedSpecialties=true&limit=10&offset=0`,
  );
});

/**
 *
 * Get the data!
 *
 */
async function getData() {
  try {
    const responses = await Promise.all(
      apiArr.map(async (url) => {
        const response = await fetch(url);

        // Check for HTTP errors and throw informative error
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse JSON and handle potential parsing errors
        try {
          return await response.json();
        } catch (error) {
          console.error(`Error parsing JSON from ${url}:`, error);
          return null;
        }
      }),
    );

    // Use the successfully fetched and parsed responses here
    return responses;
  } catch (error) {
    console.error("General error fetching data:", error);
  }
}

/**
 *
 * Renders the results after getting the job deets
 *
 */
async function renderResults() {
  const data = await getData();
  // console.log(data);
  // data.forEach((d) => console.log(d.items[0].professionCode));

  data.forEach((d) =>
    generateMarkup(d.items, "results-container-" + d.items[0].professionCode),
  );
}

/**
 *
 * Slugify job details
 *
 */
const makeSlug = (str) => {
  if (str) {
    str = str.toLowerCase();
    str = str.replace(/[^a-z0-9]+/g, "-");
    str = str.replace(/^-+|-+$/g, "");
    return str;
  }
  return "";
};

/**
 *
 * Generate html markup
 *
 */
function generateMarkup(jobs, elContainer) {
  let jobsMarkup = ``;
  // let caption = '';
  let counter = 1;
  jobs.forEach((job) => {
    let jobLocation = ``;

    if (job.city && job.stateAbbrev) {
      jobLocation = `${job.city}, ${job.stateAbbrev}`;
    } else if (job.stateAbbrev && job.state) {
      jobLocation = `${job.state}`;
    }

    let regularPayLow = job.regularPayLow;
    let regularPayHigh, regularPayHighRounded, regularPayLowRounded;
    regularPayLowRounded = Math.round(regularPayLow).toLocaleString();
    regularPayHigh = job.regularPayHigh;
    regularPayHighRounded = Math.round(regularPayHigh).toLocaleString();

    let customPayShift = job.customPayShift;

    let transparentPay = ``;

    if (customPayShift) {
      transparentPay = customPayShift;
    } else if (regularPayLow == regularPayHigh) {
      transparentPay = "$" + regularPayHighRounded + "/shift";
    } else if (job.payPeriodTypeId == 2) {
      transparentPay =
        "$" +
        regularPayLowRounded +
        "/day - $" +
        regularPayHighRounded +
        "/day";
    } else if (job.payPeriodTypeId == 1) {
      transparentPay =
        "$" + regularPayLowRounded + "/hr - $" + regularPayHighRounded + "/hr";
    } else {
      transparentPay =
        "$" + regularPayLowRounded + "/hr - $" + regularPayHighRounded + "/hr";
    }

    let professionSlug = makeSlug(job.professionText);
    let expertiseSlug = makeSlug(job.expertiseText);
    let citySlug = makeSlug(job.city);
    let stateSlug = makeSlug(job.state);

    // caption = job.professionText;

    const profText =
      job.professionText === job.expertiseText
        ? `Locum ${job.professionText} Job`
        : `Locum ${job.professionText} ${job.expertiseText} Job`;

    const professionAndExpertise =
      professionSlug === expertiseSlug
        ? professionSlug
        : `${professionSlug}-${expertiseSlug}`;

    if (jobLocation && counter <= 4) {
      jobsMarkup += `<tr data-id="${job.jobID}">`;
      jobsMarkup += `   <th class="job job-title" scope="row">`;
      jobsMarkup += `       <h2><a href="/job/locum-${professionAndExpertise}-${citySlug}-${stateSlug}/${job.jobID}/" target="_blank">${profText}</a></h2>`;
      jobsMarkup += `   </th>`;
      // jobsMarkup += `   <td class="job job-category">`;
      // jobsMarkup += `       <h3>${job.expertiseText}</h3>`;
      // jobsMarkup += `   </td>`;
      jobsMarkup += `   <td class="job job-location">`;
      jobsMarkup += `       <h3>${jobLocation}</h3>`;
      jobsMarkup += `   </td>`;
      jobsMarkup += `   <td class="job job-pay">`;
      jobsMarkup += `       <h3>${transparentPay}</h3>`;
      jobsMarkup += `   </td>`;
      jobsMarkup += `   <td class="job job-apply">`;
      jobsMarkup += `       <a href="/job/locum-${professionAndExpertise}-${citySlug}-${stateSlug}/${job.jobID}/" class="btn primary-outline" target="_blank">Apply</a>`;
      jobsMarkup += `   </td>`;
      jobsMarkup += `</tr>`;
      counter += 1;
    }
  });

  document.querySelector(`#${elContainer} tbody`).innerHTML = jobsMarkup;
}

renderResults();

const iframes = document.querySelectorAll("#content iframe");
iframes.forEach((i) => {
  i.parentElement.classList.add("embed-container");
});

const scrollTopBtn = document.querySelector(".scroll-to-top");
window.addEventListener("scroll", () => {
  scrollTopBtn.classList.remove("show");
  if (window.scrollY > 1000) {
    scrollTopBtn.classList.add("show");
  }
});
scrollTopBtn.addEventListener("click", () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});
